module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/sweatshirt/5-27a9faa2befcf6802a6d3525d77c4014.jpg";